import React, {useContext, useEffect, useRef, useState} from "react";
import LOGO from "../img/LOGO.png";
import lg from "../img/lg.png"
import flowers from "../img/flowers.png"
import crest from "../img/crest.png"
import ochnislogow from "../img/ochnislogow.png"
import og360 from "../img/og360.jpg"
import LocaleSwitch from "../components/LocaleSwitch";
import {LanguageContext} from "../App";
import {Link} from "react-router-dom";
import {isMobile} from "react-device-detect";
import {Helmet} from "react-helmet";

import { Gallery, Item } from 'react-photoswipe-gallery'
import 'photoswipe/dist/photoswipe.css'


import PhotoAlbum from "react-photo-album";

import Map, {Layer, Marker, NavigationControl, ScaleControl, Source} from 'react-map-gl';
import { createClient } from '@supabase/supabase-js'


const TOKEN = 'pk.eyJ1IjoidGltb2ZlamFuZHJvcG92IiwiYSI6ImNsMG1zN3pyNTE1eWczY25zd2ExcHNkd3EifQ.bAxtoJwQXLx_e2ZWpYa1fQ';
const supabase = createClient('https://sxipkzxjsnnaybxthrxf.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN4aXBrenhqc25uYXlieHRocnhmIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzY3NDEwMzgsImV4cCI6MTk5MjMxNzAzOH0.ToB8TL555TnCAjl_jmNdhY86bmTvttL5K1aRAlZUOI8')

const YearPage = () => {
    const {language} = useContext(LanguageContext)

    const [ groupsList, setGroupsList ] = useState({})
    const [ content, setContent ] = useState({})

    const [ citiesCount, setCitiesCount] = useState(0)
    const [ pointsCount, setPointsCount ] = useState(0)
    const [ regionsCount, setRegionsCount ] = useState(0)

    const windowSize = useRef([window.innerWidth, window.innerHeight]);

    const [zoom, setZoom] = useState()
    const [mapHeight, setMapHeight] = useState(620)

    const [ images, setImages ] = useState([])
    //36.209016, 25.517773
    //81.288226, -163.014719
    const bounds = [
        [14.0000, 40.0000], // [west, south]
        [-170.0000, 78.0000]  // [east, north]
    ];

    // const [viewport, setViewport] = useState({
    //     latitude: 64.17,
    //     longitude: 105.13,
    //     zoom: 2,
    //     maxZoom: 4,
    //     minZoom: 1,
    //     bearing: 0,
    //     pitch: 0
    // });

    //
    const [ points, setPoints ] = useState({})

    async function fetchPhotos () {
        const { data, error } = await supabase
            .from('images')
            .select('*')
            .order('created_at',  { ascending: false })
            .limit(10)
        // console.log(data)
        return data
    }

    // useEffect(() => {
    //     if ( windowSize.current[0] < 800) {
    //         setMapHeight(200)
    //         setZoom(1)
    //     } else {
    //         setZoom(2)
    //         setMapHeight(620)
    //     }
    // },[windowSize])

    // zoom: if (windowSize.current[0]<400) re,
        // zoom: {(windowSize.current[0]) => {
        // if ( windowSize.current[0] < 400) return 1;
        // if ( windowSize.current[0] < 600) return 2;
        // if ( windowSize.current[0] < 900) return 3;
        // return 4;}},


    useEffect(() => {
        async function fetchData () {
            const { data, error } = await supabase
                .from('cities')
                .select('value, label, geo_lat, geo_lon, count, region')
                .gt('count', 0)
            return data
        }
        fetchData().then((data)=>{
            setCitiesCount(data.length)
            let count = 0
            let features = []
            let regions = []
            data.map((point) => {
                regions.push(point.region)
                for (let i = 0; i < point.count; i++) {
                    count++
                    features.push(
                        {type: 'Feature', geometry: {type: 'Point', coordinates: [point.geo_lon, point.geo_lat]}},
                    )
                }
            })
            // console.log(regions)
            setRegionsCount(new Set(regions).size)

            setPoints({
                type: 'FeatureCollection',
                features: features
            })
            setPointsCount(features.length)
        })
        fetchPhotos().then((data)=>{
            setImages(data)
        })


    },[])

    const [isMobileMenu, setIsMobileMenu] = useState(false)

    const mmenuShow = () => {
        console.log('mclick')
        setIsMobileMenu(true)
        console.log(content.fields.text_md)
    }
    const mmenuHide = () => {
        setIsMobileMenu(false)
    }


    const photos = images.map((photo) => ({
        src: photo.cdn_url,
        width: photo.crop ? photo.crop_width : photo.width,
        height: photo.crop ? photo.crop_height : photo.height,
        city: photo.city,
        address: photo.address,
        source: photo.source
        // images: breakpoints.map((breakpoint) => {
        //     const height = Math.round((photo.height / photo.width) * breakpoint);
        //     return {
        //         src: unsplashLink(photo.id, breakpoint, height),
        //         width: breakpoint,
        //         height,
        //     };
        // }),
    }));


     const clusterLayer = {
        id: 'clusters',
        type: 'circle',
        source: 'earthquakes',
        filter: ['has', 'point_count'],
        paint: {
            // 'circle-color': ['step', ['get', 'point_count'], '#51bbd6', 50, '#f1f075', 100, '#f28cb1'],
            'circle-color': ['step', ['get', 'point_count'], '#51bbd6', 50, '#51bbd6', 100, '#f1f075'],
            'circle-radius': ['step', ['get', 'point_count'], 13, 10, 15, 20, 20, 50, 25, 100, 30]
        }
    };

     const clusterCountLayer = {
        id: 'cluster-count',
        type: 'symbol',
        source: 'earthquakes',
        filter: ['has', 'point_count'],
        layout: {
            'text-field': '{point_count_abbreviated}',
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
            'text-size': 12
        }
    };

    const unclusteredPointLayer = {
        id: 'unclustered-point',
        type: 'circle',
        source: 'earthquakes',
        filter: ['!', ['has', 'point_count']],
        paint: {
            'circle-color': '#11b4da',
            'circle-radius': 5,
            'circle-stroke-width': 1,
            'circle-stroke-color': '#fff'
        }
    };

    const PhotoRenderer = ({ photo, wrapperStyle, renderDefaultPhoto, restWrapperProps }) => {
        const { width, height,  src, uuid, city, source, address} = photo;
        // console.log(photo)
        const caption = address ?
                    `
                    <div class="bg-black/50 p-4">
                        <h3 class="font-bold">${city}</h3>
                        <p class="italic">${address}</p>
                        <a href='${source}'>🔗 источник</a>
                    </div>
                    `
                   :
                     `
                    <div class="bg-black/50 p-4">
                        <h3 class="font-bold">${city}</h3>
                        <a href='${source}'>🔗 источник</a>
                    </div>
                    `


        return (
            <div
                key={uuid}
                style={{
                    // width: style.width,
                    // padding: style.padding,
                    // marginBottom: style.marginBottom,
                    ...wrapperStyle
                }}
                {...restWrapperProps}
                className='relative pb-1'
            >
                <Item
                    // content={<h1 className='text-white'>Hi!</h1>}
                    caption={caption}
                    // alt='asdafeef'
                    original={src}
                    thumbnail={src}
                    width={width}
                    height={height}
                    key={uuid}
                >
                    {({ref, open}) => (
                        <div ref={ref}>
                            <img src={src}
                                 className='cursor-pointer rounded'
                                 onClick={open}
                                 width={width}
                                 height={height}
                            />
                            {/*<img*/}
                            {/*    quality={50}*/}
                            {/*    // key = {id}*/}
                            {/*    loading={"lazy"}*/}
                            {/*    width={width}*/}
                            {/*    height={height}*/}
                            {/*    placeholder={"blur"}*/}
                            {/*    blurDataURL={'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDVPuMlKfGrFErmCt6hCuECLbbhekJF-GCtAJvPIZpHX5upTT-hABFlp8qZY8rkgaZ0DE&usqp=CAU'}*/}

                            {/*    src={photo_public_url}*/}
                            {/*/>*/}
                        </div>

                    )}
                </Item>
                <div className='text-neutral-100 text-center pt-1'>
                    {city}
                </div>
            </div>
            // <div style={{position: "relative", ...wrapperStyle}}>
            //     {renderDefaultPhoto({wrapped: true})}
            //     {photo.title && (
            //         <div
            //             style={{
            //                 position: "absolute",
            //                 overflow: "hidden",
            //                 backgroundColor: "rgba(255 255 255 / .6)",
            //                 inset: "auto 0 0 0",
            //                 padding: 8,
            //             }}
            //         >
            //             {photo.city}
            //         </div>
            //     )}
            // </div>
        )

    }

    return (
        <div className=' bg-black'>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Россия скорбит</title>
                <meta name="description" content="24.02.2023 - День памяти и скорби"/>

                {/*Facebook Meta Tags*/}
                <meta property="og:url" content="https://remap-ru.com/360"/>
                <meta property="og:type" content="website"/>
                <meta property="og:title" content="Россия скорбит"/>
                <meta property="og:description" content="24.02.2023 - День памяти и скорби"/>
                <meta property="og:image" content={og360}/>

                <meta name="twitter:card" content="summary_large_image"/>
                <meta property="twitter:domain" content="remap-ru.com"/>
                <meta property="twitter:url" content="https://remap-ru.com/360"/>
                <meta name="twitter:title" content="Россия скорбит"/>
                <meta name="twitter:description" content="24.02.2023 - День памяти и скорби"/>
                <meta name="twitter:image" content={og360}/>

            </Helmet>

            <main className='bg-black'>
                <div className='py-20 bg-gradient-to-b from-neutral-900/80 via-neutral-900/50 '>
                    <div className='flex max-w-7xl mx-auto items-center px-3'>
                        <div className='w-auto'>
                            <img src={lg} width={80} alt=""/>
                        </div>
                        <div className='pl-6'>
                            <h2 className='text-xl md:text-2xl font-bold text-neutral-400'>24.02.2023</h2>
                            <h1 className='text-2xl md:text-4xl font-bold text-neutral-100 pt-1'>РОССИЯ СКОРБИТ</h1>
                            <h1 className='text-xl md:text-2xl font-bold text-neutral-400 pt-1'>День памяти и скорби*</h1>
                        </div>
                    </div>
                    {/*<img src={low} alt=""/>*/}


                </div>
                <div className='max-w-7xl m-auto'>
                    <div className='bg-black mx-auto '>
                        <Map
                            //{...viewport}
                            // onMove={evt => setViewport(evt.viewState)}
                            attributionControl={false}
                            initialViewState={{
                                latitude: 64.17,
                                longitude: 105.13,
                                zoom: 0,
                                maxZoom: 5,
                                // minZoom: 2,
                                bearing: 0,
                                pitch: 0
                            }}
                            scrollZoom={false}
                            mapboxAccessToken={TOKEN}
                            style={ (windowSize.current[0] < 600) ? { height: 189} : { height: 620}}
                            maxBounds= {bounds}
                            // mapStyle="mapbox://styles/mapbox/streets-v9"
                            mapStyle="mapbox://styles/timofejandropov/cle8rbg3m006m01q9jmhcehee"

                        >
                            <NavigationControl
                                position="top-right"
                                showCompass={false}
                            />
                            <Source
                                id="memorials"
                                type="geojson"
                                data={points}
                                cluster={true}
                                clusterMaxZoom={14}
                                clusterRadius={20}
                            >
                                <Layer {...clusterLayer} />
                                <Layer {...clusterCountLayer} />
                                <Layer {...unclusteredPointLayer} />
                            </Source>
                            {/*<Marker*/}
                            {/*    key={'cluster-1'}*/}
                            {/*    latitude='64.0000'*/}
                            {/*    longitude='105.0000'*/}
                            {/*    anchor="top"*/}
                            {/*>*/}
                            {/*    <div*/}
                            {/*        className="rounded-full bg-gradient-to-b from-red-500 to-red-900 flex items-baseline*/}
                            {/*        hover:cursor-pointer"*/}
                            {/*        style={{*/}
                            {/*            width: `40px`,*/}
                            {/*            height: `40px`*/}
                            {/*        }}*/}
                            {/*        // onClick={() => {*/}
                            {/*        //     const expansionZoom = Math.min(*/}
                            {/*        //         supercluster.getClusterExpansionZoom(cluster.id),*/}
                            {/*        //         20*/}
                            {/*        //     );*/}
                            {/*        //     main_map.flyTo({center: [longitude, latitude], zoom:expansionZoom});*/}
                            {/*        // }}*/}
                            {/*    >*/}
                            {/*        <span className='m-auto text-white'>*/}
                            {/*            { '5' }*/}
                            {/*        </span>*/}
                            {/*    </div>*/}
                            {/*</Marker>*/}
                        </Map>
                    </div>
                    <div className='flex flex-col md:flex-row text-white pt-12 px-3 justify-center md:gap-20'>
                        <div className='text-center md:text-left'>
                            <div className='text-4xl font-bold'>
                                {regionsCount}
                            </div>
                            <div className='text-xl text-neutral-400'>
                                Регионов
                            </div>
                        </div>
                        <div className='w-1/2 mx-auto md:mx-0 md:w-fit border my-4 border-neutral-500'></div>
                        <div className='text-center md:text-left'>
                            <div className='text-4xl font-bold'>
                                {citiesCount}
                            </div>
                            <div className='text-xl text-neutral-400'>
                                Городов
                            </div>
                        </div>
                        <div className='w-1/2 mx-auto md:mx-0 md:w-fit border my-4 border-neutral-500'></div>
                        <div className='text-center md:text-left'>
                            <div className='text-4xl font-bold'>
                                {pointsCount}
                            </div>
                            <div className='text-xl text-neutral-400'>
                                Мемориалов
                            </div>
                        </div>
                    </div>
                </div>
                <div className='max-w-7xl mx-auto pt-20 px-3'>
                    <div className='border p-8 rounded-md bg-neutral-900/50 border-neutral-900'>
                        <div className='text-md'>
                            <div className='text-lg text-neutral-300'>
                                День памяти и скорби* - самопровозглашенный движением <a className='text-blue-300 font-bold' href="https://t.me/vesna_democrat">«Весна»</a> и <a className='text-blue-300 font-bold' href="https://t.me/femagainstwar">ФАС</a> день скорби о жертвах
                                российской агрессии против Украины.
                            </div>
                            <div className='text-neutral-400 pt-2'>
                                Стимулом для этого стало возростающее количиство стихийных мемориалов в результате ракетного обстрела по Днепру, где
                                погибло <a className='text-blue-300 font-bold' href="https://ru.wikipedia.org/wiki/%D0%A0%D0%B0%D0%BA%D0%B5%D1%82%D0%BD%D1%8B%D0%B9_%D0%BE%D0%B1%D1%81%D1%82%D1%80%D0%B5%D0%BB_%D0%A3%D0%BA%D1%80%D0%B0%D0%B8%D0%BD%D1%8B_14_%D1%8F%D0%BD%D0%B2%D0%B0%D1%80%D1%8F_2023_%D0%B3%D0%BE%D0%B4%D0%B0">46</a> невинных украинцев. А также, в связи с годовщиной начала так называемой "специальной военной операции" в результате которой погибло уже более <a className='text-blue-300 font-bold'
                                href="https://www.ohchr.org/ru/news/2023/01/ukraine-civilian-casualty-update-30-january-2023">7110</a> (ООН) мирных жителей Украины.
                            </div>
                        </div>
                    </div>
                </div>
                <div className='bg-neutral-900/60 mt-20 py-12'>
                    <div className='max-w-7xl mx-auto px-12 pt-4 text-neutral-400'>
                        <div className='text-lg pb-4 text-neutral-300'>
                            Несмотря на репрессии и запугивания со стороны режима люди по всей России:
                        </div>
                        <div className='flex items-center py-2'>
                            <img src={flowers} width={40} alt=""/>
                            <p className='pl-4'>Приносят цветы, свечи и игрушки к связанным с украинской культурой памятникам</p>
                        </div>
                        <div className='flex items-center py-2'>
                            <img src={crest} width={40} alt=""/>
                            <p className='pl-4'>Сооружают собственные, самодельные мемориалы</p>
                        </div>
                        <div className='flex items-center pt-2'>
                            <img src={lg} width={40} alt=""/>
                            <p className='pl-4'>Завязывают черные ленты в своих городах</p>
                        </div>
                    </div>
                </div>

                <div className='py-12'>
                    <div className='max-w-7xl mx-auto px-8'>
                        <div className='text-2xl font-bold text-neutral-300 text-center'>
                            ФОТОГАЛЕРЕЯ
                        </div>
                        <div className='pt-12'>
                            <Gallery withCaption>
                                <PhotoAlbum
                                    layout="columns"
                                    // columns={3}
                                    columns={(containerWidth) => {
                                        if (containerWidth < 400) return 1;
                                        if (containerWidth < 600) return 2;
                                        if (containerWidth < 900) return 3;
                                        return 4;
                                    }}
                                    photos={photos}
                                    renderPhoto={PhotoRenderer}
                                />
                            </Gallery>

                        </div>
                    </div>
                    <div className='flex justify-center pt-8'>
                        <Link to="photos">
                            <div className='bg-blue-400 hover:bg-blue-400/90 px-5 py-2 rounded cursor-pointer'>Больше фото</div>
                        </Link>
                    </div>
                </div>

                <div className='bg-neutral-800/60 mt-10 pt-4 pb-8'>
                    <div className='max-w-7xl mx-auto px-12 pt-4 text-neutral-400'>
                        <div className="flex flex-col items-center justify-center">
                            <div className="text-center">Сайт разработан
                                при поддержке движения
                            </div>
                            <a target="_blank" rel="noreferrer" href="https://t.me/wakeup_russia"><img className="pt-4"
                                                                                                       width="160"
                                                                                                       height="46"
                                                                                                       src={ochnislogow}
                                                                                                       alt="Движение ОЧНИСЬ"/></a></div>
                    </div>
                </div>

            </main>
        </div>
    )
}

export default YearPage